import axiosInstance from "../../core/axiosConfig.ts";
import * as Sentry from '@sentry/react';

export default class SupportService {
    async getConversations() {
        const response = await axiosInstance.get('/support/conversations/list');
        return response.data;
    }

    async getMessages(conversationSid: string) {
        const response = await axiosInstance.get(
            `/support/messages/list?conversationSid=${conversationSid}`
        );
        console.log("responseData: "+JSON.stringify(response.data));
        return response.data;
    }
    
    async sendMessage(conversationSid: string, body: string) {
        try {
            const response = await axiosInstance.post('/support/messages/send', {
                conversationSid,
                body
            });
            console.log('sendMessage response:', response.status, response.data);
        } catch (e: any) {
            console.error('sendMessage error:', e.response?.status, e.response?.data);
            Sentry.captureException(e);
            throw e;
        }
    }

    async deleteConversation(conversationSid: string) {
        const response = await axiosInstance.delete(
            `/support/conversation/delete?conversationSid=${conversationSid}`
        );
        console.log("responseData: "+JSON.stringify(response.data));
        return response.data;
    }

    async getTwilioToken() {
        const response = await axiosInstance.get(
            '/support/token/get'
        );
        console.log("responseData: "+JSON.stringify(response.data));
        return response.data;
    }
}